import React from 'react'
import Header from './Header'
import Footer from './Footer'

function About() {
  return (
    <>
    <Header />
   
    <div className='about_section layout_padding'>
         <div class="container-fluid">
                <div class="row">
                  <div class="col-md-6 padding_left0">
                      <div class="about_taital_main">
                        <h1 class="about_taital">DHK Service Oy</h1>
                        <h6 class="about_text">At DHK Service Oy, we are committed to providing a one-stop solution for all your business needs. With expertise across multiple sectors, we deliver high-quality services designed to enhance efficiency, streamline operations, and support your growth. Our goal is to offer reliable, professional, and tailored solutions that cater to diverse industries.</h6>
                       
                        <div class="btn_main">

                        <h2>Why Choose Us?</h2>
                           <ul class="about_text">
                              <li><i class="fa fa-thumbs-up"></i> Excellent Quality</li>
                                 <li><i class="fa fa-thumbs-up"></i> Trusted Partner</li>
                                 <li><i class="fa fa-thumbs-up"></i> Best Prices Ever</li>
                                 <li><i class="fa fa-thumbs-up"></i> Experienced Workers</li>
                                 <li><i class="fa fa-thumbs-up"></i> Empowered Employees</li>
                                 <li><i class="fa fa-thumbs-up"></i> Environment Friendly</li>
                           </ul>
                           
                            <div class="started_bt"><a href="#">Contact Us</a></div>
                           
                          
                        </div>

                        
                      </div>

                      
                  </div>
                  <div class="col-md-6">
                      <div class="about_img"><img src="Assets/images/about-img.png" /></div>
                  </div>
                </div>
         </div>

    </div>

    <Footer />
    </>
  )
}

export default About